// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__l_r55","name":"Header_name__3fRIc","birthday":"Header_birthday__1YTkl","skeleton":"Header_skeleton__1-rE0"};